import { ParameterFailureModel } from 'api/data-contracts'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const validatedFailures = (error: any, fallbackMessage: string) => {
  if ('error' in error && 'failures' in error.error) {
    const errors = error.error.failures.map(
      (failure: ParameterFailureModel) => failure?.failureReason,
    )
    return errors.join(', ')
  }
  return fallbackMessage
}
